/* eslint-disable */

import {
  Flex,
  Box,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Tfoot,
  useColorModeValue,
  Button,
  useToast,
  Link
} from '@chakra-ui/react';
import * as React from 'react';
import ReactPaginate from 'react-paginate'

import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';

// Custom components
import Card from 'components/card/Card';
import Menu from 'components/menu/MainMenu';
import { commonFetch } from '@/utils/util'

const items = [...Array(33).keys()];

const columnHelper = createColumnHelper();

// const columns = columnsDataCheck;
export default function ColumnTable(props) {
  const { tableData, onDetail } = props;
  const [sorting, setSorting] = React.useState([]);
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const toast = useToast();

  let defaultData = tableData;
  const columns = [
    columnHelper.accessor('amount', {
      id: 'amount',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
        >
          支付金额
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize="sm" fontWeight="700">
          ¥ {(info.row.original.amount / 100).toFixed(2)}
        </Text>
      ),
    }),
    // columnHelper.accessor('mchFeeAmount', {
    //   id: 'mchFeeAmount',
    //   header: () => (
    //     <Text
    //       justifyContent="space-between"
    //       align="center"
    //       fontSize={{ sm: '10px', lg: '12px' }}
    //       color="gray.400"
    //     >
    //       手续费
    //     </Text>
    //   ),
    //   cell: (info) => (
    //     <Text color={textColor} fontSize="sm" fontWeight="700">
    //       ¥ {(info.row.original.mchFeeAmount / 100).toFixed(2)}
    //     </Text>
    //   ),
    // }),
    columnHelper.accessor('actualChangeBalance', {
      id: 'actualChangeBalance',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
        >
          手续费
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize="sm" fontWeight="700">
          ¥ {info.row.original.actualChangeBalance }
        </Text>
      ),
    }),
    columnHelper.accessor('quantity', {
      id: 'quantity',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
        >
          订单号
        </Text>
      ),
      cell: (info) => {
        // console.log(info, 'info')
        return (
          <Flex direction={'column'}>
            <Flex align={'center'} mb="5px">
              {/* <Box bg="brand.200" textAlign={'center'} padding={'4px 6px'} borderRadius={'4px'} mr="4px">
                <Text color={'#fff'} fontSize="sm" fontWeight="700">
                  支付
                </Text>
              </Box> */}
              <Text color={'gray.500'}>{info.row.original.payOrderId}</Text>
            </Flex>
            {/* <Flex align={'center'}>
              <Box bg="green.500" textAlign={'center'} padding={'4px 6px'} borderRadius={'4px'} mr="4px">
                <Text color={'#fff'} fontSize="sm" fontWeight="700">
                  商户
                </Text>
              </Box>
              <Text color={'gray.500'}>{info.row.original.mchNo}</Text>
            </Flex> */}
          </Flex>
        )
      }
    }),
    columnHelper.accessor('date', {
      id: 'date3',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
        >
          支付方式
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize="sm" fontWeight="700">
          {info.row.original.wayName}
        </Text>
      ),
    }),
    columnHelper.accessor('date', {
      id: 'date2',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
        >
          支付状态
        </Text>
      ),
      cell: (info) => (
        <Flex>
          <Box bg={
            {
              0: 'orange.500',
              1: 'brand.500',
              2: 'green.500',
              3: 'red.500',
              4: 'red.500',
              5: 'red.500',
              6: 'gray.500'
            }[info.row.original.state] || 'gray.500'
          } textAlign={'center'} padding={'4px 6px'} borderRadius={'4px'} mr="4px">
            <Text color={'#fff'} fontSize="sm" fontWeight="700">
              {
                {
                  0: '订单生成',
                  1: '支付中',
                  2: '支付成功',
                  3: '支付失败',
                  4: '已撤销',
                  5: '已退款',
                  6: '订单关闭'
                }[info.row.original.state] || '未知'
              }
            </Text>
          </Box>
        </Flex>
      ),
    }),
    columnHelper.accessor('createdAt', {
      id: 'createdAt',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
        >
          创建日期
        </Text>
      ),
      cell: (info) => (
        <Flex align="center">
          <Text color={textColor} fontSize="sm" fontWeight="700">
            {info.row.original.createdAt}
          </Text>
        </Flex>
      ),
    }),
    columnHelper.accessor('date', {
      id: 'date0',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
        >
          操作
        </Text>
      ),
      cell: (info) => (
        <Link color="brand.500" onClick={() => onDetail(info.row.original)}>详情</Link>
      ),
    }),
    // columnHelper.accessor('amount', {
    //   id: 'amount',
    //   header: () => (
    //     <Text
    //       justifyContent="space-between"
    //       align="center"
    //       fontSize={{ sm: '10px', lg: '12px' }}
    //       color="gray.400"
    //     >
    //       消费金额
    //     </Text>
    //   ),
    //   cell: (info) => (
    //     <Text color={textColor} fontSize="sm" fontWeight="700">
    //       ¥ {(info.getValue() / 100).toFixed(2)}
    //     </Text>
    //   ),
    // }),
    // columnHelper.accessor('date', {
    //   id: 'date2',
    //   header: () => (
    //     <Text
    //       justifyContent="space-between"
    //       align="center"
    //       fontSize={{ sm: '10px', lg: '12px' }}
    //       color="gray.400"
    //     >
    //       交易状态
    //     </Text>
    //   ),
    //   cell: (info) => (
    //     <>
    //       <Flex>
    //         {info.row.original.state === 0 && (
    //           <Box bg="orange.500" textAlign={'center'} padding={'4px 6px'} borderRadius={'4px'} mr="4px">
    //             <Text color={'#fff'} fontSize="sm" fontWeight="700">
    //               订单生成
    //             </Text>
    //           </Box>
    //         )}
    //         {info.row.original.state === 1 && (
    //           <Box bg="brand.500" textAlign={'center'} padding={'4px 6px'} borderRadius={'4px'} mr="4px">
    //             <Text color={'#fff'} fontSize="sm" fontWeight="700">
    //             支付中
    //             </Text>
    //           </Box>
    //         )}
    //         {info.row.original.state === 2 && (
    //           <Box bg="green.500" textAlign={'center'} padding={'4px 6px'} borderRadius={'4px'} mr="4px">
    //             <Text color={'#fff'} fontSize="sm" fontWeight="700">
    //             支付成功
    //             </Text>
    //           </Box>
    //         )}
    //         {info.row.original.state === 3 && (
    //           <Box bg="red.500" textAlign={'center'} padding={'4px 6px'} borderRadius={'4px'} mr="4px">
    //             <Text color={'#fff'} fontSize="sm" fontWeight="700">
    //             支付失败
    //             </Text>
    //           </Box>
    //         )}
    //         {info.row.original.state === 4 && (
    //           <Box bg="red.500" textAlign={'center'} padding={'4px 6px'} borderRadius={'4px'} mr="4px">
    //             <Text color={'#fff'} fontSize="sm" fontWeight="700">
    //             已撤销
    //             </Text>
    //           </Box>
    //         )}
    //         {info.row.original.state === 5 && (
    //           <Box bg="red.500" textAlign={'center'} padding={'4px 6px'} borderRadius={'4px'} mr="4px">
    //             <Text color={'#fff'} fontSize="sm" fontWeight="700">
    //             已退款
    //             </Text>
    //           </Box>
    //         )}
    //          {info.row.original.state === 6 && (
    //           <Box bg="gray.500" textAlign={'center'} padding={'4px 6px'} borderRadius={'4px'} mr="4px">
    //             <Text color={'#fff'} fontSize="sm" fontWeight="700">
    //             订单关闭
    //             </Text>
    //           </Box>
    //         )}
    //       </Flex>
    //     </>
    //   ),
    // }),
    // columnHelper.accessor('mchOrderNo', {
    //   id: 'mchOrderNo',
    //   header: () => (
    //     <Text
    //       justifyContent="space-between"
    //       align="center"
    //       fontSize={{ sm: '10px', lg: '12px' }}
    //       color="gray.400"
    //     >
    //       交易参考号
    //     </Text>
    //   ),
    //   cell: (info) => (
    //     <Text color={textColor} fontSize="sm" fontWeight="700">
    //       {info.getValue()}
    //     </Text>
    //   ),
    // }),
    // columnHelper.accessor('payOrderId', {
    //   id: 'payOrderId',
    //   header: () => (
    //     <Text
    //       justifyContent="space-between"
    //       align="center"
    //       fontSize={{ sm: '10px', lg: '12px' }}
    //       color="gray.400"
    //     >
    //       关联订单
    //     </Text>
    //   ),
    //   cell: (info) => (
    //     <Text color={textColor} fontSize="sm" fontWeight="700">
    //       {info.getValue()}
    //     </Text>
    //   ),
    // })
  ];
  const [data, setData] = React.useState(() => []);
  const table = useReactTable({
    data,
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    debugTable: true,
  });

  
  const itemsPerPage = 4
  const [itemOffset, setItemOffset] = React.useState(0);

  const [pageNumber, setPageNumber] = React.useState(1);
  const [pageCount, setPageCount] = React.useState(1);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    setPageNumber(event.selected + 1)
  };

  React.useEffect(() => {
    commonFetch({
      url: '/api/consumption/pay/page',
      method: 'get',
      params: {
        pageNumber: pageNumber,
        pageSize: 10
      }
    }, toast).then(res => {
      setData(res.records)
      setPageCount(Math.ceil(res.total / 10))
    })
  }, [pageNumber])
  return (
    <Card
      flexDirection="column"
      w="100%"
      px="0px"
      overflowX={{ sm: 'scroll', lg: 'hidden' }}
    >
      {/* <Flex px="25px" mb="8px" justifyContent="space-between" align="center">
        <Text
          color={textColor}
          fontSize="22px"
          mb="4px"
          fontWeight="700"
          lineHeight="100%"
        >
          4-Columns Table
        </Text>
        <Menu />
      </Flex> */}
      {data.length ? (
        <Box>
          <Table variant="simple" color="gray.500" mb="24px" mt="12px">
            <Thead>
              {table.getHeaderGroups().map((headerGroup) => (
                <Tr key={headerGroup.id}>
                  {headerGroup.headers.map((header) => {
                    return (
                      <Th
                        key={header.id}
                        colSpan={header.colSpan}
                        pe="10px"
                        borderColor={borderColor}
                        cursor="pointer"
                        onClick={header.column.getToggleSortingHandler()}
                      >
                        <Flex
                          justifyContent="space-between"
                          align="center"
                          fontSize={{ sm: '10px', lg: '12px' }}
                          color="gray.400"
                        >
                          {flexRender(
                            header.column.columnDef.header,
                            header.getContext(),
                          )}
                          {{
                            asc: '',
                            desc: '',
                          }[header.column.getIsSorted()] ?? null}
                        </Flex>
                      </Th>
                    );
                  })}
                </Tr>
              ))}
            </Thead>
            <Tbody>
              {table
                .getRowModel()
                .rows.slice(0, 11)
                .map((row) => {
                  return (
                    <Tr key={row.id}>
                      {row.getVisibleCells().map((cell) => {
                        return (
                          <Td
                            key={cell.id}
                            fontSize={{ sm: '14px' }}
                            minW={{ sm: '150px', md: '200px', lg: 'auto' }}
                            borderColor="transparent"
                          >
                            {flexRender(
                              cell.column.columnDef.cell,
                              cell.getContext(),
                            )}
                          </Td>
                        );
                      })}
                    </Tr>
                  );
                })}
            </Tbody>
          </Table>
          <Flex mt="-20px" mr="30px" justifyContent={'flex-end'}>
            <ReactPaginate
              breakLabel="..."
              nextLabel=">"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={pageCount}
              previousLabel="<"
              renderOnZeroPageCount={null}
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination"
              activeClassName="active"
            />
          </Flex>
        </Box>
      ) : (
        <>
          <Table variant="simple" color="gray.500" mb="24px" mt="12px">
            <Thead>
              {table.getHeaderGroups().map((headerGroup) => (
                <Tr key={headerGroup.id}>
                  {headerGroup.headers.map((header) => {
                    return (
                      <Th
                        key={header.id}
                        colSpan={header.colSpan}
                        pe="10px"
                        borderColor={borderColor}
                        cursor="pointer"
                        onClick={header.column.getToggleSortingHandler()}
                      >
                        <Flex
                          justifyContent="space-between"
                          align="center"
                          fontSize={{ sm: '10px', lg: '12px' }}
                          color="gray.400"
                        >
                          {flexRender(
                            header.column.columnDef.header,
                            header.getContext(),
                          )}
                          {{
                            asc: '',
                            desc: '',
                          }[header.column.getIsSorted()] ?? null}
                        </Flex>
                      </Th>
                    );
                  })}
                </Tr>
              ))}
            </Thead>
          </Table>
          <Flex height={"200px"} justify={"center"} align={"center"}>
            <Text color={'gray.500'} fontSize={"18px"}>暂无数据</Text>
          </Flex>
        </>
      )}
    </Card>
  );
}
